module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      John W. Stewart\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('B', [_vm._v("John W. Stewart")]), _vm._v(" (1934–2023) was the Ralph B. and Helen S. Ashenfelter Associate Professor of Ministry and Evangelism Emeritus at Princeton Theological Seminary. Ordained in the Presbyterian Church, Stewart served as pastor at churches in Pennsylvania and Michigan and authored numerous books and articles on Presbyterian history.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/ciH8RV/tc-custom/9781467443241.jpg?1708514683880",
      "alt": "This image is the cover for the book Envisioning the Congregation, Practicing the Gospel"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Envisioning the Congregation, Practicing the Gospel\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("This accessible and instructive book is designed to equip lay leaders of Protestant churches to better envision and practice gospel-driven ministry and mission in contemporary society."), _c('br'), _c('br'), _vm._v("Seasoned pastor and practical theologian John Stewart presents and explains five biblically mandated, foundational practices for being and nurturing the church: fellowship, discipleship, witness, service, and worship. Stewart argues that these five practices are normative, indispensable, and doable for congregations that seek to remain faithful to their risen Lord, and he offers memorable, achievable models of ways they are already being used in current mainline congregations.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Wm. B. Eerdmans Publishing \n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0